// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD3OOJvGzQ-chGdjpYpeBv4G8Asg1GcpQw",
    authDomain: "oshop-e3600.firebaseapp.com",
    databaseURL: "https://oshop-e3600.firebaseio.com",
    projectId: "oshop-e3600",
    storageBucket: "",
    messagingSenderId: "442683870535"
  }
};



// WEBPACK FOOTER //
// C:/React/Antique/src/environments/environment.ts